import { FC, useRef } from "react";

import { AnimationStyles, IStackProps, mergeStyles } from "@bps/fluent-ui";
import { ContactType } from "@libs/gateways/practice/PracticeGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { Contact } from "@stores/practice/models/Contact.ts";

import { PreferredArgs } from "../PreferredCheckBox.tsx";
import { ContactMethodListCommunicationsItem } from "./ContactMethodListCommunicationsItem.tsx";
import { sortedCommunications } from "./utils.ts";

type ContactMethodListCommunicationsProps = {
  contact: Contact;
  isOrganisation?: boolean;
  asBullet?: boolean;
};

export const ContactMethodListCommunications: FC<
  ContactMethodListCommunicationsProps
> = ({ contact, isOrganisation, asBullet }) => {
  const preferredNew = useRef<boolean>(false);
  const { practice } = useStores();

  const onPreferredClick = async (preferredArgs: PreferredArgs) => {
    const communications = contact.communications.slice().map(x => ({
      type: x.type,
      value: x.value,
      preferred: !(
        x.type === preferredArgs.preferredOptions?.type &&
        x.value === preferredArgs.preferredOptions.value
      )
        ? false
        : !x.preferred
    }));
    preferredNew.current = true;
    contact.type === ContactType.Patient
      ? await practice.updatePatient({
          id: contact.id,
          communications
        })
      : await practice.updateIndividual({
          id: contact.id,
          communications
        });
    preferredNew.current = false;
  };

  return (
    <>
      {sortedCommunications(contact.communications).map(item => {
        let className: IStackProps["className"];
        if (isOrganisation) {
          className = "noSelect";
        } else if (item.preferred && preferredNew) {
          className = mergeStyles({ ...AnimationStyles.slideRightIn40 });
        }

        return (
          <ContactMethodListCommunicationsItem
            asBullet={asBullet}
            contact={contact}
            onPreferredClick={onPreferredClick}
            isOrganisation={isOrganisation}
            className={className}
            key={item.value}
            item={item}
          />
        );
      })}
    </>
  );
};
